import script from "./QuestionEditorComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionEditorComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionEditorComponent.vue?vue&type=style&index=0&id=e705703c&lang=scss"
import "./QuestionEditorComponent.vue?vue&type=style&index=1&id=e705703c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e705703c"]])

export default __exports__